import { useState, useEffect } from "react";
import { Navbar, Nav, Container, Button, NavDropdown } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { logoutUser } from "../../store/authSlice";
import { authLogout } from "../../server";
import routersJson from 'data/routers.json';
import SearchBanner from "./SearchBanner";
import { wsDisconnect } from "store/websocketSlice";
import { baseOrigin, baseOrigin2 } from "config";

/* ================= styled ================= */

const NETWORK_LINES = [
  {
    name: 'line1',
    route: "Line1",
    url: baseOrigin,
  },
  {
    name: "line2",
    route: "Line2",
    url: baseOrigin2,
  },
];

const StyledNavbar = styled(Navbar)`
  height: 100px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
`;

const StyledNav = styled(Nav)`
  flex: 1;
  justify-content: center;
  gap: 100px;
`;

const StyledNavLink = styled(Nav.Link)`
  position: relative;
  color: #000 !important;
  font-size: 22px;
  font-weight: 600;
  transition: all 0.3s ease;

  &.active {
    color: #005FA3 !important;
  }

  &::after {
    content: "";
    position: absolute;
    left: 50%;
    bottom: -4px;
    width: 0;
    height: 2px;
    background: #005FA3;
    transition: all 0.3s ease;
  }

  &:hover::after {
    color: #005FA3 !important;
    width: 100%;
    left: 0;
  }
`;
/* ================= component ================= */

const PortalHeader = () => {
  const { t, i18n } = useTranslation("portal");
  const dispatch = useDispatch();
  const location = useLocation();
  const [langMenuOpen, setLangMenuOpen] = useState(false);
  const [networkMenuOpen, setNetworkMenuOpen] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const currentNetwork =
    JSON.parse(sessionStorage.getItem("network")) || {};
  /* 登录状态 */
  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  /* 切换线路 */
  const switchNetwork = (line) => {
    const network = {
      route: line.route,
      url: line.url,
      name: line.name,
      success: true,
      time: 0,
    };

    sessionStorage.setItem(
      "network",
      JSON.stringify(network)
    );
    window.location.reload();
  };

  /* 退出登录 */
  const handleLogout = async () => {
    try {
      await authLogout();
    } finally {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem('artworkNid')
      sessionStorage.removeItem('artworkNid')
      setIsLoggedIn(false);
      dispatch(logoutUser());
      dispatch(wsDisconnect());
    }
  };

  /* 语言 */
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const currentLanguageTitle =
    i18n.language === "en" ? "Language" : "语言";


  return (
    <>
      <SearchBanner />

      <StyledNavbar expand="lg" fixed="top"
      >
        <Container>
          {/* LOGO */}
          <LinkContainer to="/home">
            <Navbar.Brand>
              <img
                src={`/img/logo.png`}
                alt="logo"
                height="90"
              />
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Collapse>
            {/* 中间导航 */}
            <StyledNav>
              {routersJson.map((item) => (
                <LinkContainer to={item.path} key={item.path}>
                  <StyledNavLink
                    active={location.pathname === item.path}
                  >
                    {t(item.label)}
                  </StyledNavLink>
                </LinkContainer>
              ))}
            </StyledNav>

            {/* 右侧 */}
            <Nav className="align-items-center gap-2">

              {/* 线路切换 */}
              <div
                className="position-relative"
              >
                <Button
                  variant="primary"
                  className="d-flex align-items-center gap-2 sanger-top-btn"
                  onClick={() => {
                    setNetworkMenuOpen(!networkMenuOpen);
                  }}
                >
                  <i className="bi bi-hdd-network" />
                  {t(currentNetwork?.name || 'switchLine')}
                </Button>

                {/* 菜单 */}
                {networkMenuOpen && (
                  <>
                    {/* 遮罩 */}
                    <div
                      className="sanger-fixed"
                      onClick={() => setNetworkMenuOpen(false)}
                    />

                    <div className="sanger-menu">

                      {NETWORK_LINES.map((line) => (
                        <div
                          className="sanger-menu-item"
                          key={line.route}
                          onClick={() => {
                            switchNetwork(line);
                            setNetworkMenuOpen(false);
                          }}
                        >
                          <i
                            className="bi bi-check2"
                            style={{
                              visibility:
                                currentNetwork.url === line.url
                                  ? "visible"
                                  : "hidden",
                            }}
                          />
                          <span>
                            {t(line.name)}
                          </span>
                        </div>
                      ))}

                    </div>
                  </>
                )}

              </div>

              {/* 语言切换 */}
              <div className="position-relative">
                {/* 语言按钮 */}
                <Button
                  variant="primary"
                  className="d-flex align-items-center gap-2 sanger-top-btn"
                  onClick={() => {
                    setLangMenuOpen(!langMenuOpen);
                  }}
                >
                  <i className="bi bi-translate" />

                  {currentLanguageTitle}
                </Button>

                {/* 悬浮菜单 */}
                {langMenuOpen && (
                  <>
                    <div
                      className="sanger-fixed"
                      onClick={() => setLangMenuOpen(false)}
                    />
                    <div className="sanger-menu">
                      {/* English */}
                      <div
                        className="sanger-menu-item"
                        onClick={() => {
                          changeLanguage("en");
                          setLangMenuOpen(false);
                        }}

                      >
                        <i
                          className="bi bi-check2"
                          style={{
                            visibility:
                              i18n.language === "en"
                                ? "visible"
                                : "hidden",
                          }}
                        />

                        <span>
                          English
                        </span>

                      </div>

                      {/* 中文 */}
                      <div
                        className="sanger-menu-item"
                        onClick={() => {
                          changeLanguage("zh");
                          setLangMenuOpen(false);
                        }}
                      >
                        <i
                          className="bi bi-check2"
                          style={{
                            visibility:
                              i18n.language.startsWith("zh")
                                ? "visible"
                                : "hidden",
                          }}
                        />
                        <span>
                          简体中文
                        </span>
                      </div>
                    </div>
                  </>
                )}

              </div>

              {isLoggedIn ? (
                <>
                  <div
                    className="position-relative"
                  >

                    <Button
                      variant="primary"
                      className="d-flex align-items-center gap-2 sanger-top-btn"
                      onClick={() => {
                        setShowUserMenu(!showUserMenu);
                      }}
                    >
                      <i className="bi bi-person-circle" />
                      {t('user')}
                    </Button>

                    {showUserMenu && (
                      <>
                        <div
                          className="sanger-fixed"
                          onClick={() => setShowUserMenu(false)}
                        />
                        <div className="sanger-menu">
                          {/* 我的作品 */}
                          <div
                            className="sanger-menu-item"
                            onClick={() => {
                              window.location.href =
                                "/personal/artwork";
                            }}
                          >
                            <i className="bi-folder2-open" />
                            <span>
                              {t("myWorks")}
                            </span>
                          </div>

                          {/* 个人中心 */}
                          <div
                            className="sanger-menu-item"
                            onClick={() => {
                              window.location.href =
                                "/personal/center";
                            }}
                          >
                            <i className="bi bi-person" />
                            <span>
                              {t("personal_center")}
                            </span>
                          </div>

                          {/* 退出登录 */}
                          <div
                            onClick={handleLogout}
                            className="sanger-menu-item"
                            style={{ color: 'var(--sanger-red-color)' }}
                          >
                            <i className="bi bi-box-arrow-right" />
                            <span>
                              {t("logout")}
                            </span>
                          </div>
                        </div>
                      </>
                    )}

                  </div>
                </>
              ) : (
                /* 登录 */
                <LinkContainer to="/login">
                  <Button
                    variant="primary"
                    className="d-flex align-items-center gap-2 sanger-top-btn"
                  >
                    <i className="bi bi-box-arrow-in-right" />

                    {t("login")}
                  </Button>
                </LinkContainer>
              )}

            </Nav>
          </Navbar.Collapse>
        </Container>
      </StyledNavbar>
    </>
  );
};

export default PortalHeader;